import { render } from "./App.vue?vue&type=template&id=5c8caaa0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5c8caaa0&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__